import { render, staticRenderFns } from "./LoadingMenuTree.vue?vue&type=template&id=04a9f47c&scoped=true"
import script from "./LoadingMenuTree.vue?vue&type=script&lang=js"
export * from "./LoadingMenuTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a9f47c",
  null
  
)

export default component.exports